import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSceneLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 70,
	viewBox: "0 0 69 70",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_391_22037)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M55.5474 56.2289C67.2436 44.5045 67.2436 25.4955 55.5475 13.7711C43.8513 2.04667 24.8881 2.04667 13.1919 13.7711C1.49577 25.4955 1.49577 44.5045 13.1919 56.2289C24.8881 67.9533 43.8513 67.9533 55.5474 56.2289Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.3676 6.67914C39.9557 6.67818 45.4185 8.33835 50.0653 11.4497C54.712 14.5611 58.334 18.9838 60.4731 24.1587C62.6122 29.3336 63.1724 35.0281 62.0828 40.5221C60.9932 46.0161 58.3028 51.0629 54.3518 55.0241C50.4008 58.9853 45.3667 61.6831 39.8861 62.7763C34.4055 63.8694 28.7246 63.3089 23.5618 61.1655C18.399 59.0221 13.9863 55.3921 10.8817 50.7347C7.77701 46.0773 6.1199 40.6015 6.1199 35C6.12888 27.4924 9.1077 20.2949 14.4031 14.9858C19.6985 9.67669 26.8782 6.68944 34.3676 6.67914ZM34.3676 3.27637C28.1084 3.27637 21.9898 5.13692 16.7854 8.62276C11.5811 12.1086 7.52477 17.0631 5.12947 22.8599C2.73417 28.6566 2.10745 35.0352 3.32856 41.1889C4.54968 47.3427 7.56378 52.9953 11.9897 57.432C16.4157 61.8686 22.0546 64.89 28.1936 66.114C34.3325 67.3381 40.6957 66.7099 46.4785 64.3088C52.2612 61.9077 57.2039 57.8416 60.6813 52.6247C64.1587 47.4078 66.0148 41.2743 66.0148 35C66.0058 26.5891 62.6687 18.5253 56.7356 12.5779C50.8026 6.63057 42.7582 3.28537 34.3676 3.27637Z",
				fill: "#FF4500"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.3677 61.2403C48.8249 61.2403 60.5448 49.4921 60.5448 35C60.5448 20.5079 48.8249 8.75977 34.3677 8.75977C19.9105 8.75977 8.19067 20.5079 8.19067 35C8.19067 49.4921 19.9105 61.2403 34.3677 61.2403Z",
				fill: "url(#paint0_radial_391_22037)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.5408 48.5824C24.5855 48.1791 22.7086 47.46 20.9834 46.4532L23.9755 39.6477C25.4181 40.5073 26.9807 41.1462 28.6115 41.5435C30.337 42.0085 32.1154 42.2471 33.9022 42.2532C35.5122 42.2532 36.6567 42.0831 37.3404 41.7671C37.6384 41.6567 37.8958 41.4581 38.0786 41.1977C38.2613 40.9372 38.3607 40.6272 38.3636 40.3088C38.3636 39.6769 37.9514 39.2296 37.1319 38.9671C35.8505 38.6126 34.5438 38.3575 33.2233 38.2039C31.2676 37.9873 29.3317 37.6184 27.4331 37.1005C25.8409 36.6627 24.4019 35.7891 23.2772 34.5775C22.123 33.3525 21.5459 31.6366 21.5459 29.4296C21.5238 27.6718 22.0965 25.9583 23.1705 24.5685C24.4164 23.0353 26.0562 21.8722 27.9132 21.2046C30.3098 20.3265 32.8497 19.9077 35.4007 19.9699C37.4617 19.969 39.5174 20.1808 41.5351 20.6019C43.3104 20.932 45.0245 21.5337 46.6173 22.3859L43.6446 29.1671C41.1461 27.7702 38.3294 27.045 35.4686 27.0623C33.8925 27.0623 32.7432 27.2519 32.0109 27.6164C31.2787 27.981 30.9053 28.4671 30.9053 29.0748C30.9053 29.6824 31.3078 30.2074 32.1128 30.4699C33.4196 30.8391 34.752 31.1105 36.099 31.2817C38.0635 31.5545 40.0076 31.9589 41.9183 32.4921C43.455 32.9487 44.8415 33.8098 45.9336 34.9859C47.0683 36.1979 47.6357 37.8896 47.6357 40.0609C47.6499 41.8011 47.0775 43.4952 46.0111 44.8685C44.7547 46.402 43.0949 47.5521 41.2199 48.1887C38.771 49.0503 36.1866 49.4604 33.5918 49.3991C31.2178 49.4022 28.8516 49.1281 26.5408 48.5824Z",
				fill: "#F1F4F6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.9434 43.9641C40.9406 42.6801 40.4689 41.4417 39.6175 40.4825C38.7661 39.5233 37.5938 38.9098 36.322 38.7578C36.6178 38.8259 36.8845 38.8939 37.1076 38.9668C37.9271 39.2293 38.3393 39.6766 38.3393 40.3085C38.3364 40.6269 38.237 40.9369 38.0542 41.1974C37.8715 41.4578 37.614 41.6564 37.3161 41.7668C36.6323 42.0974 35.4879 42.2529 33.8779 42.2529C32.8493 42.2429 31.8231 42.1536 30.8082 41.9856C30.0687 41.8767 29.3355 41.729 28.6114 41.5432C26.9877 41.136 25.4334 40.4889 23.9996 39.6231L21.0076 46.4286C22.7328 47.4354 24.6097 48.1545 26.565 48.5578C28.8678 49.1016 31.2259 49.3757 33.5918 49.3745C34.324 49.3745 35.0466 49.3502 35.7109 49.3016V49.2141C37.0972 49.2064 38.4244 48.6506 39.4041 47.6676C40.3839 46.6846 40.9371 45.3536 40.9434 43.9641Z",
				fill: "url(#paint1_linear_391_22037)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.535 20.6017C39.5172 20.1806 37.4615 19.9688 35.4005 19.9697C34.4476 19.9726 33.4956 20.0294 32.5491 20.1399V20.2079C31.274 20.2589 30.0638 20.7853 29.1557 21.684C28.2475 22.5827 27.7068 23.7888 27.6395 25.0662C27.5721 26.3436 27.983 27.6002 28.7915 28.5898C29.6001 29.5794 30.7482 30.2308 32.0108 30.4163C31.264 30.1489 30.8809 29.6968 30.8809 29.0551C30.8809 28.4135 31.2494 27.9808 31.9865 27.5968C32.7236 27.2128 33.8681 27.0426 35.4441 27.0426C36.1461 27.0444 36.8472 27.0883 37.5439 27.1739C39.6882 27.4305 41.7611 28.1077 43.6445 29.167L46.6317 22.3614C45.0329 21.5162 43.3139 20.9227 41.535 20.6017Z",
				fill: "url(#paint2_linear_391_22037)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.9141 34.9709C44.822 33.7949 43.4355 32.9337 41.8988 32.4772C39.9881 31.944 38.044 31.5396 36.0795 31.2668C34.7325 31.0955 33.4001 30.8242 32.0933 30.4549L32.006 30.4209C30.7434 30.2354 29.5953 29.5841 28.7868 28.5945C27.9782 27.6049 27.5673 26.3483 27.6347 25.0709C27.7021 23.7935 28.2428 22.5873 29.1509 21.6887C30.0591 20.79 31.2692 20.2636 32.5443 20.2126V20.1445C30.9637 20.2936 29.4097 20.6516 27.9228 21.2091C26.0659 21.8766 24.426 23.0398 23.1801 24.573C22.1061 25.9628 21.5335 27.6763 21.5555 29.4341C21.5555 31.6411 22.1326 33.357 23.2868 34.582C24.4008 35.7875 25.8257 36.6606 27.4039 37.1049C29.3025 37.6229 31.2384 37.9918 33.1941 38.2084C34.4937 38.3883 35.5315 38.573 36.3171 38.7626C37.6431 38.9251 38.8572 39.5885 39.7121 40.6174C40.567 41.6463 40.9982 42.9634 40.9178 44.3C40.8374 45.6366 40.2515 46.8922 39.2794 47.8107C38.3074 48.7292 37.0225 49.2415 35.6867 49.2431V49.3306C37.5767 49.2217 39.4407 48.8368 41.2199 48.1883C43.0983 47.5485 44.76 46.3931 46.0159 44.8536C47.0822 43.4802 47.6547 41.7862 47.6405 40.0459C47.6243 37.8746 47.0488 36.183 45.9141 34.9709Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_radial_391_22037",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(28.0199 22.9639) scale(40.4731 40.5708)",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#009CDE" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .09,
					stopColor: "#0694DE"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .23,
					stopColor: "#167EDD"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .41,
					stopColor: "#305BDB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .43,
					stopColor: "#3455DB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .46,
					stopColor: "#2F53CF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .58,
					stopColor: "#1B4CA4"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .69,
					stopColor: "#0D4684"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .77,
					stopColor: "#044371"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .84,
					stopColor: "#01426A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "#064475"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .91,
					stopColor: "#134993"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .97,
					stopColor: "#2951C2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3455DB"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_391_22037",
			x1: 42.0782,
			y1: 44.0759,
			x2: 21.638,
			y2: 44.0759,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#52595D",
					stopOpacity: .3
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .19,
					stopColor: "#52595D",
					stopOpacity: .21
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "#52595D",
					stopOpacity: .05
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#52595D",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_391_22037",
			x1: 27.6269,
			y1: 25.1954,
			x2: 46.6172,
			y2: 25.1954,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					stopColor: "#52595D",
					stopOpacity: .3
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .19,
					stopColor: "#52595D",
					stopOpacity: .21
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .63,
					stopColor: "#52595D",
					stopOpacity: .05
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#52595D",
					stopOpacity: 0
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_391_22037",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 68.3133,
				height: 70,
				fill: "white"
			})
		})
	] })]
});
export default SvgSceneLogo;
